import React from 'react';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Carousel from './Carousel';
import AboutSection from '../pages/AboutSection';
import ProjectsCarousel from '../pages/ProjectsCarousel';
import ServicesSectionTwo from '../pages/servicess';
import CounterSection from '../pages/CounterSection';
import NewsSection from '../pages/NewsSection';
import TestimonialsSlider from '../pages/TestimonialsSlider';


const HeroSlider = () => {
  const settings = {
    dots: true, // Enables the dots below the slider
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
  };

  return (
  <>

    
  <Carousel/>
  <AboutSection/>
  <ProjectsCarousel/>
  <ServicesSectionTwo/>
  <CounterSection/>
  <NewsSection/>
  <TestimonialsSlider/>

  </>
  );
};

export default HeroSlider;
